import { render, staticRenderFns } from "./PaymentAccountCreate.vue?vue&type=template&id=21d9ad72&"
import script from "./PaymentAccountCreate.vue?vue&type=script&lang=js&"
export * from "./PaymentAccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports